import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`

export const CheckRow = styled(Row)`
  height: 38px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -8px #252525;
  border-radius: 15px;
  margin: 0px;
  padding: 0px 20px;
  align-items: center;
  gap: 3px;

  label { margin-bottom: 1px; }
`

export const CheckGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: flex-end;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;

  p { margin: 0px; }
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 4px;
  cursor: pointer;
`

export const InfoText = styled.p`
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
`

export const ButtonText = styled(InfoText)`
  color: #FFFFFF;
  margin: 0px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  line-height: 16px;
  margin-top: 3px;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
